module.exports = __webpack_public_path__ + "img/출금.2d6dac51.png";